// extracted by mini-css-extract-plugin
module.exports = {"root":"BookingDollarBalance_root__2cpGZ","label":"BookingDollarBalance_label__2jVBO","flag":"BookingDollarBalance_flag__2Py71","small":"BookingDollarBalance_small__Pf2bF"};